import api from "../../admin/infra/api";

const BASE = process.env.REACT_APP_API_URL + "api/calendar";

export const fetchParticipants = async (calendarId: string | number): Promise<number[]> => {
  try {
    const response = await api(`${BASE}/${calendarId}/participants`);
    if (response.ok) {
      const data: { user_id: number }[] = await response.json();
      return data.map((d) => d.user_id);
    }
    return [];
  } catch {
    return [];
  }
};

export const syncParticipants = async (
  calendarId: string | number,
  userIds: number[],
): Promise<void> => {
  await api(`${BASE}/${calendarId}/participants`, {
    method: "POST",
    body: JSON.stringify({ userIds }),
    headers: { "content-Type": "application/json" },
  });
};
